import { useEffect, useRef } from 'react';
import { chatStore } from '../stores/chatStore';
import { authStore } from '../stores/authStore';

export const useChat = () => {
  const { user } = authStore();
  const {
    conversas,
    conversaAtual,
    mensagens,
    usuariosOnline,
    digitando,
    conectado,
    carregando,
    erro,
    inicializar,
    desconectar,
    selecionarConversa,
    enviarMensagem,
    indicarDigitando,
    marcarComoLida,
    atualizarConversas,
    limparErro,
    isUsuarioOnline,
  } = chatStore();

  const typingTimeoutRef = useRef(null);
  const inicializadoRef = useRef(false);

  useEffect(() => {
    if (user?.id && !inicializadoRef.current) {
      inicializar(user.id);
      inicializadoRef.current = true;
    }

    return () => {
    };
  }, [user?.id]);

  // Funções auxiliares
  const handleEnviarMensagem = (conteudo, tipo = 'texto') => {
    if (!conversaAtual || !conteudo.trim()) return;
    enviarMensagem(user.id, conversaAtual.outroUsuario.id, conteudo, tipo);
  };

  const handleSelecionarConversa = (conversa) => {
    selecionarConversa(conversa, user.id);
  };

  const handleDigitando = (digitando = true) => {
    if (!conversaAtual) return;

    indicarDigitando(user.id, conversaAtual.outroUsuario.id, digitando);

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    if (digitando) {
      typingTimeoutRef.current = setTimeout(() => {
        indicarDigitando(user.id, conversaAtual.outroUsuario.id, false);
      }, 1000);
    }
  };

  const handleMarcarLida = (mensagemId) => {
    marcarComoLida(user.id, mensagemId);
  };

  const isOutroUsuarioOnline = () => {
    if (!conversaAtual) return false;
    return isUsuarioOnline(conversaAtual.outroUsuario.id);
  };

  return {
    conversas,
    conversaAtual,
    mensagens,
    usuariosOnline,
    digitando,
    conectado,
    carregando,
    erro,
    user,

    selecionarConversa: handleSelecionarConversa,
    enviarMensagem: handleEnviarMensagem,
    indicarDigitando: handleDigitando,
    marcarComoLida: handleMarcarLida,
    atualizarConversas,
    limparErro,
    isOutroUsuarioOnline,
    isUsuarioOnline,
  };
};
